import React from "react"
import { Redirect, Route } from "react-router-dom"

const PrivateRoute = ({ render, authenticated, isRehydrating, ...rest }) => {
    if (authenticated || isRehydrating) {
        return <Route {...rest} render={render} />
    } else
        return (
            <Route
                {...rest}
                render={props => (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: rest.location }
                        }}
                    />
                )}
            />
        )
}

export default PrivateRoute
